import React, { useEffect, useState } from "react";
import { useGlobalContext } from "../../../../scanview/ScanViewerContext";
import CameraIcon from "../../../../assets/camera_icon.png";
import { isMobile } from "react-device-detect";
import { useScanVideoContext } from "../../../../scanview/contexts/ScanVideoContext";
import styles from "./CameraPermissionModal.module.scss";

type CameraPermissionModalTexts = {
  title: string;
  text: string;
  retryButtonText: string;
  webToMobileButtonText: string;
  helpButtonText: string;
};

const CameraPermissionModal = () => {
  const {
    cameraPermissionModalConfig,
    showErrorModal,
    webToMobileHandoffConfig,
    webToMobileTimer,
    setWebToMobileTimer,
    setShowErrorModal,
  } = useGlobalContext();
  const { retryCamera, cameraPermissionState } = useScanVideoContext();
  const [cameraPermissionModalTexts, setCameraPermissionModalTexts] =
    useState<CameraPermissionModalTexts>({
      title: "Camera Access Needed",
      text: "Allow camera access to scan your medical insurance card",
      retryButtonText: "Retry Camera Access",
      webToMobileButtonText: "Continue on Mobile Phone",
      helpButtonText: "Get help",
    });

  const continueOnMobile = () => {
    if (webToMobileHandoffConfig?.enabled === true) {
      setShowErrorModal({ ...showErrorModal, modal: "webToMobile" });
      setWebToMobileTimer(null);
    }
  };

  const getHelp = () => {
    setShowErrorModal((prev) => ({ ...prev, modal: "help" }));
    setWebToMobileTimer(null);
  };

  useEffect(() => {
    const texts = {
      ...(cameraPermissionModalConfig?.title
        ? { title: cameraPermissionModalConfig.title }
        : {}),
      ...(cameraPermissionModalConfig?.text
        ? { text: cameraPermissionModalConfig.text }
        : {}),
      ...(cameraPermissionModalConfig?.retryButtonText
        ? { retryButtonText: cameraPermissionModalConfig.retryButtonText }
        : {}),
      ...(cameraPermissionModalConfig?.webToMobileButtonText
        ? {
            webToMobileButtonText:
              cameraPermissionModalConfig.webToMobileButtonText,
          }
        : {}),
      ...(cameraPermissionModalConfig?.helpButtonText
        ? { helpButtonText: cameraPermissionModalConfig.helpButtonText }
        : {}),
    };
    if (Object.keys(texts).length) {
      setCameraPermissionModalTexts((prev) => ({
        ...prev,
        ...cameraPermissionModalConfig,
      }));
    }
  }, [cameraPermissionModalConfig]);

  useEffect(() => {
    if (webToMobileTimer !== null && webToMobileTimer > 0) {
      const interval = setInterval(() => {
        setWebToMobileTimer((prev) => {
          if (prev === null) return prev;
          if (prev === 0) return 0;
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    } else if (webToMobileTimer === 0) {
      continueOnMobile();
    }
  }, [webToMobileTimer]);

  if (!showErrorModal) {
    return <></>;
  }

  return (
    <div className={styles.cameraPermissionModalMainContainer}>
      <img
        className={styles.icon}
        src={CameraIcon}
        alt="camera with sparkles"
      />
      <h2 className={styles.modalTitle}>{cameraPermissionModalTexts.title}</h2>
      <p className={styles.modalText}>{cameraPermissionModalTexts.text}</p>
      {cameraPermissionState !== "hardblock" && (
        <button className={styles.primaryBtn} onClick={retryCamera}>
          {cameraPermissionModalTexts.retryButtonText}
        </button>
      )}
      {!isMobile && webToMobileHandoffConfig?.enabled === true && (
        <button className={styles.secondaryBtn} onClick={continueOnMobile}>
          {cameraPermissionModalTexts.webToMobileButtonText}{" "}
          {webToMobileHandoffConfig.enabled === true &&
            webToMobileTimer &&
            `(${webToMobileTimer}s)`}
        </button>
      )}
      <button className={styles.secondaryBtn} onClick={getHelp}>
        {cameraPermissionModalTexts.helpButtonText}
      </button>
    </div>
  );
};

export default CameraPermissionModal;
